import React from "react";
import { Container, Grid } from "@mui/material";

export default function AppMainContainer({ children }) {
    return (
        <section className="mainBox">
            <Container maxWidth={false}>
                <Grid container>{children}</Grid>
            </Container>
        </section>
    );
}
